"use strict";
"use client";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useDrawer_exports = {};
__export(useDrawer_exports, {
  DrawerStateProvider: () => DrawerStateProvider,
  useDrawer: () => useDrawer
});
module.exports = __toCommonJS(useDrawer_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_routers = require("@react-navigation/routers");
var import_react = require("react");
var import_getPathFromState = require("../fork/getPathFromState");
var import_linkingConfig = require("../router/linkingConfig");
var DrawerContext = /* @__PURE__ */ (0, import_react.createContext)(null);
function DrawerStateProvider(param) {
  var { state, descriptors, navigation, children } = param;
  var linking = (0, import_linkingConfig.getResolvedLinking)();
  var value = (0, import_react.useMemo)(function() {
    var screens = state.routes.map(function(route, index) {
      var _ref, _route_params;
      var descriptor = descriptors[route.key];
      var options = descriptor.options;
      var href = ((_ref = linking === null || linking === void 0 ? void 0 : linking.getPathFromState) !== null && _ref !== void 0 ? _ref : import_getPathFromState.getPathFromState)({
        ...state,
        index
      }, linking === null || linking === void 0 ? void 0 : linking.config);
      return {
        key: route.key,
        name: route.name,
        params: (_route_params = route.params) !== null && _route_params !== void 0 ? _route_params : {},
        href,
        isFocused: index === state.index,
        keepMounted: options.keepMounted === true,
        options,
        element: descriptor.render()
      };
    });
    return {
      screens,
      focused: screens[state.index],
      isOpen: state.history.some(function(entry) {
        return entry.type === "drawer";
      }),
      open: function open() {
        return navigation.dispatch(import_routers.DrawerActions.openDrawer());
      },
      close: function close() {
        return navigation.dispatch(import_routers.DrawerActions.closeDrawer());
      },
      toggle: function toggle() {
        return navigation.dispatch(import_routers.DrawerActions.toggleDrawer());
      }
    };
  }, [
    descriptors,
    linking,
    navigation,
    state
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DrawerContext.Provider, {
    value,
    children
  });
}
function useDrawer() {
  var value = (0, import_react.useContext)(DrawerContext);
  if (!value) {
    throw new Error("useDrawer must be used inside a Drawer navigator");
  }
  return value;
}
//# sourceMappingURL=useDrawer.js.map
